import { UIComponentProps, UIComponentState, UIComponentImpl, UIDataModel, UIComponentHandler } from '../../toolkit/uicomponent';
import { BaseContext } from '../../../utils/basecontext';
import { UIComponentView } from '../../toolkit/uicomponentview';
import { NavigationViewImpl } from './navigationview';
import { UIComponentCSSStyle } from '../../toolkit/uicomponentcss';
import { NavigationCSSStyleImpl } from './navigationcss';
import { LanguageConst } from '../../../utils/resources/languageconst';
import { RoutingFeatures } from './routingfeature';

export interface NavigationComponentHandler extends UIComponentHandler
{
    routeNextFeature(feature: RoutingFeatures, isRedirectionRequired: boolean): void;
}

export class NavigationComponent extends UIComponentImpl<UIComponentProps, UIComponentState, UIDataModel> implements NavigationComponentHandler
{
    UNSAFE_componentWillMount()
    {
        // window.scrollTo(0,0);
        this.updatePageLayoutBasedonLanguage(this.props.context.getUserContext().getLanguage());

        
        window.addEventListener('error', (e) =>
         {
            this.props.context.getRedirectionHandler().routeNextFeature(
                this.props.context.getRoutingPath() + "/" + RoutingFeatures.ERROR, false);

                // window.location.reload(false);

            return false;
          });

          window.addEventListener('unhandledrejection',  (e) => {
            this.props.context.getRedirectionHandler().routeNextFeature(
                this.props.context.getRoutingPath() + "/" + RoutingFeatures.ERROR, false);

                // window.location.reload(false);
          });
        super.UNSAFE_componentWillMount();
    }

    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new NavigationViewImpl(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new NavigationCSSStyleImpl(applicationContext);
    }
    
    routeNextFeature(routingFeature: RoutingFeatures, isRedirectionRequired: boolean): void 
    {
        this.props.context.getRedirectionHandler().routeNextFeature(this.props.context.getRoutingPath() +
        "/" + routingFeature, isRedirectionRequired);
    }

    
    // componentWillUnmount()
    // {
    //     console.log("componentWillUnmount invoked");
        
    //     this.props.context.logout();
    // }

    private updatePageLayoutBasedonLanguage(selectedLanguage: LanguageConst)
    {
        let rootDiv = document.getElementById("root");

        if(rootDiv !== null)
        {
            if(selectedLanguage === LanguageConst.ENGLISH)
            {
                rootDiv.dir = "ltr";
                rootDiv.lang = "en";
                rootDiv.style.fontFamily = this.props.context.getResources().getFontFamily();
            }
            else
            {
                rootDiv.dir = "ltr";
                rootDiv.lang = "my";
                rootDiv.style.fontFamily = this.props.context.getResources().getFontFamily();
            }
        }
    }

}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/navigation/navigationcomponent.tsx